import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { matchPath } from 'react-router';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { AsyncAppComponents, SyncGeneralComponents, PageNotFound } from '../routerComponents';
import NotificationPanel from './shared/notifications/NotificationPanel';
import LoadingComponent from './loading';
import LoadingBar from './loadingBar';

const ConnectedNotifications = connect(state => {
    const { events } = state.notifications;
    return { events };
})(NotificationPanel);

const createLoadableComponents = components => {
    return Object.entries(components).reduce((acc, [componentName, componentValue]) => {
        const loaderComponent = Loadable({
            loader: componentValue,
            loading: () => <LoadingComponent type="app" />,
        });

        return { ...acc, [componentName]: loaderComponent };
    }, {});
};

const appComponents = createLoadableComponents(AsyncAppComponents);
const generalComponents = createLoadableComponents(SyncGeneralComponents);

export default class Content extends Component {
    constructor(props) {
        super(props);

        this.state = {
            routes: this.createRoutes(this.props.appRoutes),
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.appRoutes !== this.props.appRoutes) {
            this.setState({ routes: this.createRoutes(this.props.appRoutes) });
        }
    }

    createRoutes(routes) {
        const mappedRoutes = Object.keys(routes).reduce((prev, routeName) => {
            const route = routes[routeName];
            const loaderComponent = appComponents[route.component] || generalComponents[route.component] || null;

            if (loaderComponent) {
                const isExact = route.hasOwnProperty('exact') ? route.exact : true;

                prev.push(<Route {...route} exact={isExact} component={loaderComponent} key={routeName} />);
            }

            return prev;
        }, []);

        mappedRoutes.push(<Route component={PageNotFound} key="not-found" />);

        return mappedRoutes;
    }

    render() {
        if (window.singlemode) {
            const { context = {} } = this.props;
            const pathname =
                this.props.parentPath ||
                this.props.pathname ||
                (this.props.location && this.props.location.pathname) ||
                this.props.location;
            const route =
                this.props.appRoutes[pathname] ||
                Object.values(this.props.appRoutes).find(r => !!matchPath(pathname, { path: r.path, exact: true, strict: true }));

            const match = route && matchPath(pathname, { path: route.path, exact: true, strict: true });
            const Component = (route && appComponents[route.component]) || PageNotFound;

            return (
                <div className="main-content-wrapper">
                    <LoadingBar />
                    <ConnectedNotifications />
                    <div className="page-wrapper">
                        <Component match={match} location={this.props.location} history={this.props.history} {...context} />
                    </div>
                </div>
            );
        }

        return (
            <div className="main-content-wrapper">
                <LoadingBar />
                <ConnectedNotifications />
                <div className="page-wrapper">
                    <Switch>{this.state.routes}</Switch>
                </div>
            </div>
        );
    }
}
